import { render, staticRenderFns } from "./AlternativeApproverRules.vue?vue&type=template&id=6c2da141&scoped=true&"
import script from "./AlternativeApproverRules.vue?vue&type=script&lang=js&"
export * from "./AlternativeApproverRules.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeApproverRules.vue?vue&type=style&index=0&id=6c2da141&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2da141",
  null
  
)

export default component.exports